import palette from './palette'

export default {
  alert: {
    background: {
      danger: palette.poppy2,
      info: palette.lightGray,
      success: palette.fern2,
      warning: palette.lightYellow,
    },
    dismiss: {
      danger: palette.white,
      info: palette.skyBlue2,
      success: palette.white,
      warning: palette.white,
    },
    message: {
      danger: palette.white,
      info: palette.almostBlack,
      success: palette.white,
      warning: palette.almostBlack,
    },
  },
  background: palette.whiteDove,
  border: {
    active: palette.skyBlue2,
    default: palette.chrome,
    disabled: palette.lightGray,
    error: palette.poppy,
  },
  text: {
    active: palette.skyBlue2,
    danger: palette.poppy2,
    default: palette.almostBlack,
    disabled: palette.chrome,
    error: palette.poppy2,
    heading: palette.black,
    hint: palette.mediumGray,
    muted: palette.mediumGray,
    title: palette.black,
  },
}
